export default "__VITE_ASSET__ysTA$qZJ__"